import { StellateDisciplinesInstancesReaderService } from '@/services/undergrad/stellate/stellate-disciplines-instances-reader.service';
import {
  GetDisciplineInstanceInfoResult,
  GetDisciplinesByCourseResult,
} from '@/models/undergrad/services/disciplines-reader.model';
import { UndergradLive } from '@/models/undergrad/undergrad-live.model';
import { DisciplineInstanceService } from './pegasus-epona/discipline-instance.service';
import { UserDisciplinesService } from './pegasus-epona/user-disciplines.service';

export class DisciplinesInstancesReaderService {
  public static async getDisciplinesAndCyclesByCourse(
    courseId: string,
  ): Promise<GetDisciplinesByCourseResult> {
    const modules = await UserDisciplinesService.getModulesWithDisciplinesByCourseId(courseId);

    return {
      disciplinesData: modules
        .map((module) =>
          module.disciplines.map((discipline) => ({
            ...discipline,
            description: '',
            submoduleId: module.moduleId,
            submoduleName: module.displayName || module.name,
            submoduleType: module.type,
            type: 'default',
            lives: {},
            lessons: {},
            grade: 0,
          })),
        )
        .flat(),
      cyclesData: modules.map((module) => ({
        id: module.moduleId,
        name: module.displayName || module.name,
        blocked: false,
        disciplineIds: module.disciplines.map((d) => d.id),
      })),
    };
  }

  public static async getDisciplineInstanceInfo(
    courseId: string,
    disciplineId: string,
  ): Promise<GetDisciplineInstanceInfoResult> {
    return DisciplineInstanceService.getDisciplineInstance(courseId, disciplineId);
  }

  public static async getDisciplineInstanceLives(
    disciplineInstanceId: string,
  ): Promise<UndergradLive[]> {
    return StellateDisciplinesInstancesReaderService.getDisciplineInstanceLives(
      disciplineInstanceId,
    );
  }
}
